export default __webpack_public_path__ + "static/media/team5.5e678b25.jpg";